import React from 'react';
import Container from 'react-bootstrap/Container';
import { t } from '../../../../i18n';
import { communicateIcon, giftCardIcon, keyIcon, scribbleShineLeftImage } from '../../../assets';
import SectionHeader from '../section-header';
import './styles.scss';

const GiftCardInstructions = () => {
  return (
    <section className="gift-card-instructions">
      <Container className="gift-card-instructions__header">
        <SectionHeader className="gift-card-instructions__header-text">
          {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS_HEADER')}
          <img src={scribbleShineLeftImage} alt="Shine" className="gift-card-instructions__header-scribble" />
        </SectionHeader>
      </Container>
      <div className="gift-card-instructions__list-background">
        <Container className="gift-card-instructions__list">
          <div className="gift-card-instructions__item">
            <img className="gift-card-instructions__icon" src={giftCardIcon} alt="Gift card" />
            <p className="gift-card-instructions__title">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TITLE_1')}
            </p>
            <p className="gift-card-instructions__text">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TEXT_1')}
            </p>
          </div>
          <div className="gift-card-instructions__item">
            <img className="gift-card-instructions__icon" src={communicateIcon} alt="Gift card" />
            <p className="gift-card-instructions__title">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TITLE_2')}
            </p>
            <p className="gift-card-instructions__text">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TEXT_2')}
            </p>
          </div>
          <div className="gift-card-instructions__item">
            <img className="gift-card-instructions__icon" src={keyIcon} alt="Gift card" />
            <p className="gift-card-instructions__title">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TITLE_3')}
            </p>
            <p className="gift-card-instructions__text">
              {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.INSTRUCTIONS.TEXT_3')}
            </p>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default GiftCardInstructions;
